<template>
  <page-outline :title="activateSpinner ? '' : $t('mandate.backgroundjob.title')">
      <template #pageContent>
        <b-container fluid>
          <!-- ACTION BAR -->
          <b-row>
            <b-col cols="12" class="d-flex justify-content-end mt-3">
              <!-- Filter toggle -->
              <b-button class="btnFilter_2 mr-2 w-100" @click="displayFilter = !displayFilter">
                <i v-if="displayFilter" class="fa-light fa-minus"></i>
                <i v-else class="fa-light fa-plus"></i>
                {{ $t('filter.fltr') }}
              </b-button>
              <!-- Refresh -->
              <b-button class="btnFilter_2 w-100" @click="onRefresh">
                <i class="fa-light fa-rotate-right"></i>
                {{ $t('common.rfrsh') }}
              </b-button>
            </b-col>
          </b-row>

          <hr class="mx-auto" />

          <!-- FILTERS -->
          <b-row v-if="displayFilter" class="min-w-100 justify-content-start align-items-center">
            <b-col cols="3">
              <div>
                <span class="filter-item-title d-block mb-1">{{ $t('mandate.backgroundjob.datetimestartbegin') }}</span>
                <datetime-picker-custom
                  format="YYYY-MM-DD HH:mm:ss"
                  periodFull
                  id="filter-datebegin"
                  class="mr-3"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': startDateBegin}"
                  customInputParentClass="filter-item-content"
                  customInputClass="w-100"
                  style="padding:0.35rem"
                  :maxLength="19"
                  :placeholderValue="$t('common.datepicker_format_date2')"
                  inputIcon="fa-solid fa-calendar"

                  v-model="startDateBegin"/>
              </div>
            </b-col>

            <b-col cols="3">
              <div>
                <span class="filter-item-title d-block mb-1">{{ $t('mandate.backgroundjob.datetimestartend') }}</span>
                <datetime-picker-custom
                  format="YYYY-MM-DD HH:mm:ss"
                  periodFull
                  id="filter-datebegin"
                  class="mr-3"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': startDateEnd}"
                  customInputParentClass="filter-item-content"
                  customInputClass="w-100"
                  style="padding:0.35rem"
                  :maxLength="19"
                  :placeholderValue="$t('common.datepicker_format_date2')"
                  inputIcon="fa-solid fa-calendar"

                  v-model="startDateEnd"/>
              </div>
            </b-col>

            <b-col cols="3">
              <div>
                <span class="filter-item-title d-block mb-1">{{ $t('mandate.backgroundjob.datetimelastupdatebegin') }}</span>
                <datetime-picker-custom
                  format="YYYY-MM-DD HH:mm:ss"
                  periodFull
                  id="filter-datebegin"
                  class="mr-3"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': lastUpdatedDateBegin}"
                  customInputParentClass="filter-item-content"
                  customInputClass="w-100"
                  style="padding:0.35rem"
                  :maxLength="19"
                  :placeholderValue="$t('common.datepicker_format_date2')"
                  inputIcon="fa-solid fa-calendar"

                  v-model="lastUpdatedDateBegin"/>
              </div>
            </b-col>

            <b-col cols="3">
              <div>
                <span class="filter-item-title d-block mb-1">{{ $t('mandate.backgroundjob.datetimelastupdateend') }}</span>
                <datetime-picker-custom
                  format="YYYY-MM-DD HH:mm:ss"
                  periodFull
                  id="filter-datebegin"
                  class="mr-3"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': lastUpdatedDateEnd}"
                  customInputParentClass="filter-item-content"
                  customInputClass="w-100"
                  style="padding:0.35rem"
                  :maxLength="19"
                  :placeholderValue="$t('common.datepicker_format_date2')"
                  inputIcon="fa-solid fa-calendar"

                  v-model="lastUpdatedDateEnd"/>
              </div>
            </b-col>

            <b-col cols="12" class="d-flex justify-content-end mt-3">
              <b-button class="btnFilter_2 mr-2 w-100" @click="clearFilterFields" :disabled="!hasInputFilter">
                {{ $t('common.rst') }}
              </b-button>
              <b-button class="btnFilter_2 w-100" @click="onRefresh">
                {{ $t('common.srch') }}
              </b-button>
            </b-col>
          </b-row>

          <hr class="mx-auto mb-4" v-if="displayFilter"/>
          <!-- TABLE -->
          <b-row>
            <b-col cols="12" class="mx-auto mb-4">
              <div style="overflow:auto">
                <spinner v-if="activateSpinner"></spinner>
                <b-table v-else-if="listItemsBackgroundJob.length > 0"
                  hover
                  striped
                  responsive
                  class="table table-striped"
                  style="margin-bottom:0"
                  :items="listItemsBackgroundJob"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDir"
                  @head-clicked="sortTable"
                  :key="refreshKey"
                  :empty-text="$t('common.security.no_result')">
                  <template #cell(description)="data">
                    <div v-if="data.value === 'export_pain008'">
                      {{ $t('mandate.backgroundjob.sdd_remittance_file') }}
                    </div>
                  </template>
                  <template #cell(status)="data">
                    <div v-if="data.value === '1'">
                      <i class="fa-duotone fa-xmark btn btn-icon btn-icon-red"></i>
                    </div>
                    <!-- <div v-else-if="data.value === '2'">
                      <i class="fa-duotone fa-warning btn btn-icon btn-icon-orange"></i>
                    </div> -->
                    <div v-else-if="data.value === '2'">
                      <i class="fa-duotone fa-check btn btn-icon btn-icon-green"></i>
                    </div>
                  </template>
                  <template #cell(datetimeStart)="data">
                    <span v-if="data.value !== ''"> {{ getDate(data.value) }}</span>
                    <span v-else>-</span>
                  </template>
                  <template #cell(datetimeLastUpdate)="data">
                    <span v-if="data.value !== ''"> {{ getDate(data.value) }}</span>
                    <span v-else>-</span>
                  </template>
                  <template #cell(action)="data">
                    <span
                      class="text-center d-inline-block py-4 w-100 action-eye"
                      role="button"
                      @click="exportSDDRemittanceFile(data.item)"
                      :title="$t('mandate.backgroundjob.action')"
                    >
                      <i class="fa-regular fa-download"></i>
                    </span>
                  </template>
                </b-table>
                <div v-else class="d-flex justify-content-center">
                  <span class="noResult">
                    {{ $t('common.no_result') }}
                  </span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col>
              <cm-pagination
                :maxResultsByPage="paginationObject.maxResults"
                :firstIndex="paginationObject.firstIndex"
                :nbResultsTotal="paginationObject.nbResultsTotal"
                :refreshEvent="paginationObject.refresh">
              </cm-pagination>
            </b-col>
          </b-row>
        </b-container>
      </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import Spinner from "@/components/common/spinner.vue"
import Pagination from '@/components/common/pagination.vue'
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import moment from 'moment-timezone'

export default {
  name: 'BackgroundJobPage',
  components: {
    'page-outline': PageOutline,
    'datetime-picker-custom': dateTimePicker,
    spinner: Spinner,
    'cm-pagination': Pagination,
  },
  data () {
    return {
      activateSpinner: false,
      BackgroundJobListExport: {},
      dateBeginFilter: null,
      dateEndFilter: null,
      displayFilter: false,
      fields: [
        { key: 'description', label: this.$t('mandate.backgroundjob.file'), class:'text-center', sortable: true },
        { key: 'companyName', label: this.$t('mandate.backgroundjob.company'), class:'text-center', sortable: true },
        { key: 'status', label: this.$t('mandate.backgroundjob.status'), class:'text-center', sortable: true },
        { key: 'datetimeStart', label: this.$t('mandate.backgroundjob.datetimestart'), class:'text-center', sortable: true },
        { key: 'datetimeLastUpdate', label: this.$t('mandate.backgroundjob.datetimelastupdate'), class:'text-center', sortable: true },
        { key: 'action', label: this.$t('mandate.backgroundjob.action'), class:'text-center', sortable: false }
      ],
      filterConditions: {},
      listItemsBackgroundJob: [],
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      sortBy: '',
      sortDir: false,
      Status: 'All',
      statuses: [
        { value: 0, label: 'administration.no' },
        { value: 1, label: 'common.security.not_started_yet' },
        { value: 2, label: 'administration.yes' }
      ],
      timezone: '+00:00',
      startDateBegin: null,
      startDateEnd: null,
      lastUpdatedDateBegin: null,
      lastUpdatedDateEnd: null
    }
  },
  created() {
    this.timezone = moment.tz.guess()

    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    // this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getBackgroundJob(index)
      that.pageCounter = 0
    })

    this.pageCounter = 0
    this.onRefresh()
  },
  computed: {
    hasInputFilter () {
      return this.startDateBegin || this.startDateEnd || this.lastUpdatedDateBegin || this.lastUpdatedDateEnd
    }
  },
  methods: {
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getBackgroundJob()
    },
    clearFilterFields () {
      this.startDateBegin = null
      this.startDateEnd = null
      this.lastUpdatedDateBegin = null
      this.lastUpdatedDateEnd = null
    },
    exportSDDRemittanceFile (job) {
      const data = job && job.jobData
      if (!data) {
        this.$f7.alert('', 'Aucun fichier disponible pour cette tâche.')
        return
      }
      this.$f7.hidePreloader()
      let linkSource = `data:application/xml;charset=utf-8;base64,${data}`;
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = `SDD_remittance_${moment().unix()}.xml`
      if (
      this.$f7.device.os === 'android' ||
      this.$f7.device.os === 'ios'
      ) {
        downloadFileWithDefinedHeaders(this, fileName, linkSource)
      } else {
      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
      }
      this.$f7.alert('', this.$i18n.t('common.exprt_succ'))

      this.$f7.pullToRefreshDone()
      this.activateSpinner = false
    },
    formatDate(dateIso) {
      if (!dateIso) return ""
      const s = String(dateIso)
      // Cas classique: "YYYY-MM-DDTHH:mm:ss"
      if (s.includes("T")) {
        return s.split("T")[0]
      }
      // Cas où backend envoie déjà juste la date
      if (s.includes(" ")) {
        return s.split(" ")[0]
      }
      return s
    },
    getBackgroundJob(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      const statusValue =
        this.Status === 'All' || this.Status === '' || this.Status == null
          ? ''
          : this.Status
      let params = {
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex,
        startDateBegin: this.startDateBegin,
        startDateEnd: this.startDateEnd,
        lastUpdatedDateBegin: this.lastUpdatedDateBegin,
        lastUpdatedDateEnd: this.lastUpdatedDateEnd
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.BackgroundJob.getBackgroundJob(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.total
        that.paginationObject.nbResults = resp.data.backgroundJobList.length

        let BackgroundJobList = {}

        BackgroundJobList = resp.data.backgroundJobList

        that.updateBackgroundJob(BackgroundJobList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    getDate (date) {
      if (!date) return '-';

      const d = new Date(String(date).replace(" ", "T"))
      if (isNaN(d)) return ""
      const pad = n => String(n).padStart(2, "0")
      return (
        `${d.getFullYear()}-` +
        `${pad(d.getMonth() + 1)}-` +
        `${pad(d.getDate())} ` +
        `${pad(d.getHours())}:` +
        `${pad(d.getMinutes())}:` +
        `${pad(d.getSeconds())}`
      )
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getBackgroundJob()
    },
    refreshList () {
      this.page = 1
      this.transactions = this.transactions.slice() // re-render
      this.applyFilter()
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'description',
        'companyName',
        'status',
        'datetimeStart',
        'datetimeLastUpdate'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateBackgroundJob(BackgroundJobList) {
      this.listItemsBackgroundJob = BackgroundJobList
    }
  }
}
</script>

<style scoped>
.status-col { width: 180px; }
.chip{
  --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151;
  display:inline-flex; align-items:center; justify-content:center;
  height:28px; min-width:150px; padding:0 .75rem; border-radius:999px;
  font-size:.75rem; font-weight:600; letter-spacing:.2px;
  border:1px solid var(--chip-border); background-color:var(--chip-bg); color:var(--chip-fg); white-space:nowrap;
}
.chip--success{ --chip-border:#16a34a; --chip-bg:rgba(22,163,74,.10); --chip-fg:#166534; }
.chip--warning{ --chip-border:#f59e0b; --chip-bg:rgba(245,158,11,.12); --chip-fg:#92400e; }
.chip--danger{  --chip-border:#ef4444; --chip-bg:rgba(239,68,68,.10); --chip-fg:#991b1b; }
.chip--secondary{ --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151; }
.chip--info{ --chip-border:#60a5fa; --chip-bg:rgba(96,165,250,.12); --chip-fg:#0b4a6f; }

.certificate-modal-content {
  width: 100%;
  text-align: left;
}

.certificate-content {
  max-height: 400px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  padding: 15px;
  border-radius: 6px;
  font-size: 11px;
  line-height: 1.5;
  text-align: left;
}

::v-deep .action-eye {
  cursor: pointer;
}
</style>
